<template>
  <div class="box1">
    <div v-loading="loading" class="box_1">
      <!-- 里面写eleCalendar组件-->
      <ele-calendar :render-content="renderContent" :disabled-date="disabledDate" :data="datedef" :prop="prop" value-format="yyyy-MM-dd" :border="true" class="calendar" @pick="clickpick" @date-change="dateChange" />
      <div v-if="stockAll || bookedAll || checked_in_all || finishAll" class="total">
        <span v-if="stockAll">{{ $t('hotel.stock_all') }}：<a>{{ stockAll }}</a></span>
        <span v-if="bookedAll">{{ $t('hotel.booked_all') }}：<a>{{ bookedAll }}</a></span><br>
        <span v-if="checked_in_all">{{ $t('hotel.checkedin_all') }}：<a>{{ checked_in_all }}</a></span>
        <span v-if="finishAll">{{ $t('hotel.finished_all') }}：<a>{{ finishAll }}</a></span>
      </div>
    </div>
    <div v-if="rightbox" class="rightbox">
      <div class="rightboxbottom">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="68px" class="demo-ruleForm">
          <el-form-item :label="$t('fleet.Typeofoperation')">
            <el-radio-group v-model="ruleForm.data.type">
              <el-radio label="1">{{ $t('fleet.increase') }}</el-radio>
              <el-radio label="-1">{{ $t('fleet.reduce') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('hotel.Stock')" prop="data.stock">
            <el-input v-model.number="ruleForm.data.stock" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">{{ $t('hotel.immediatesubmission') }}</el-button>
            <el-button @click="resetForm('ruleForm')">{{ $t('hotel.reset') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>

</template>

<script>
import base from './base'

export default {
  extends: base,
  data() {
    return {
      datas: {
        data: {
          hotel_id: '1',
          room_id: '1',
          date: ''
        },
        client_type: 'pc'
      },
      ruleForm: {
        client_type: 'pc',
        data: {
          room_id: '1',
          stock: '',
          type: '1',
          date: ''
        }
      }
    }
  }
}
</script>
